import {Injectable} from "@angular/core";
import {NgxSpinnerService} from "ngx-spinner";

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    constructor(
        private spinner: NgxSpinnerService
    ) {
    }

    showLoading(name = 'global') {
        this.spinner.show(name);
    }

    hideLoading(name = 'global') {
        this.spinner.hide(name);
    }
}
